"use client";

import { useState } from "react";

type FAQItem = {
	q: string;
	a: string;
};

export function FAQSection({ faqs }: { faqs: FAQItem[] }) {
	const [open, setOpen] = useState<number | null>(null);

	return (
		<div className="mx-auto max-w-2xl">
			<h2 className="mb-8 text-center font-sans text-2xl font-bold tracking-tight text-foreground md:text-3xl">
				Frequently asked questions
			</h2>
			<div className="divide-y divide-border rounded-xl border border-border">
				{faqs.map((faq, i) => (
					<button
						key={faq.q}
						type="button"
						onClick={() => setOpen(open === i ? null : i)}
						className="flex w-full flex-col px-5 py-4 text-left transition-colors hover:bg-muted/30"
					>
						<div className="flex items-center justify-between">
							<span className="pr-4 text-sm font-medium text-foreground">{faq.q}</span>
							<svg
								width="16"
								height="16"
								viewBox="0 0 16 16"
								className={`shrink-0 text-muted-foreground transition-transform ${open === i ? "rotate-180" : ""}`}
							>
								<path
									d="M4 6L8 10L12 6"
									stroke="currentColor"
									strokeWidth="1.5"
									fill="none"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</div>
						{open === i && (
							<p className="mt-3 text-sm leading-relaxed text-muted-foreground">{faq.a}</p>
						)}
					</button>
				))}
			</div>
		</div>
	);
}
